export default {
  ultimaSincronizacionProductos: null
}